import type {
  Dest,
  SettingGroupKey,
  Standardization,
  TaskGroupSetting,
  TaskRow,
} from '../domain/types';

/** 今後の担い手。本Gの区分 → 本社検討案 → 現場(G)。(group に 'hq' も渡せる) */
export const destOf = (task: TaskRow, group: SettingGroupKey): Dest =>
  task.groups[group].next ?? task.groups.hq.next ?? 'G';

export const standardizationOf = (task: TaskRow, group: SettingGroupKey): Standardization | null =>
  task.groups[group].standardization ?? task.groups.hq.standardization;

export const hasPlan = (setting: TaskGroupSetting): boolean =>
  setting.now !== null || setting.next !== null;
